import {
  IOrderManagementCancelReasonData,
  IOrderManagementClinicListData,
  IOrderManagementOrderListData,
  IOrderManagementOrderListProps,
  IOrderManagementStatsData,
  IQCManualAssignDeleveryData,
  IQCUserPermision,
  ITransferOrderOMSListResponseData,
  ITransferOrderStatsResponseData,
} from "@/api_framework/api_modals/Orders";
import { IUserRoleClinic } from "@/api_framework/api_modals/UserRoles";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import { ITransferOrderListResponseData } from "@/api_framework/api_modals/TransferOrder";

export type OrderManagamentStateKeys =
  | "statsList"
  | "orderList"
  | "cancelResons"
  | "clinicList"
  | "orderFilter"
  | "transferOrder"
  | "orderModule"
  | "userPermision"
  | "isCentralAdmin"
  | "isOrderSearchActive"
  | "manualAssign"
  | "transferOrderStatsList"
  | "transferOrderOmsList";

export interface IOrderManagementState {
  statsList?: IOrderManagementStatsData | null;
  orderList?: IOrderManagementOrderListData[] | null;
  totalOrders?: number;
  cancelResons?: IOrderManagementCancelReasonData[] | null;
  clinicList?: IOrderManagementClinicListData | null;
  orderclinicList?: IUserRoleClinic[] | null;
  orderFilter?: IOrderManagementOrderListProps | null;
  orderModule?: string | null;
  userPermision?: IQCUserPermision[] | null;
  isCentralAdmin?: boolean;
  isOrderSearchActive?: boolean;
  manualAssign?: IQCManualAssignDeleveryData[] | null;
  isUserPopupModalActive?: boolean;
  transferOrder: ITransferOrderListResponseData[] | null;
  transferOrderStatsList?: ITransferOrderStatsResponseData | null;
  transferOrderOmsList?: ITransferOrderOMSListResponseData[] | null;
}

export interface IOrderManagementInitialState extends IRouteReducerSliceStateInit {
  state: IOrderManagementState;
}

const initialState: IOrderManagementInitialState = {
  state: {
    orderFilter: null,
    clinicList: null,
    orderclinicList: [],
    orderModule: null,
    userPermision: [],
    isCentralAdmin: true,
    isOrderSearchActive: false,
    isUserPopupModalActive: false,
    transferOrder: [],
    orderList: [],
    totalOrders: 0,
  },
};
const orderManagementSlice = createSlice({
  name: "order_management_slice",
  initialState: initialState,
  reducers: {
    setClinicList: (
      state,
      action: PayloadAction<{
        data: IOrderManagementClinicListData;
      }>,
    ) => {
      state.state.clinicList = action.payload.data;
    },
    setOrderClinicList: (
      state,
      action: PayloadAction<{
        data: IUserRoleClinic[];
      }>,
    ) => {
      state.state.orderclinicList = action.payload.data;
    },
    setOrderStats: (
      state,
      action: PayloadAction<{
        data: IOrderManagementStatsData;
      }>,
    ) => {
      state.state.statsList = action.payload.data;
    },
    setTransferOrderStatsList: (
      state,
      action: PayloadAction<{
        data: ITransferOrderStatsResponseData;
      }>,
    ) => {
      state.state.transferOrderStatsList = action.payload.data;
    },
    setOrderList: (
      state,
      action: PayloadAction<{
        data: IOrderManagementOrderListData[];
        totalOrders: number;
      }>,
    ) => {
      state.state.orderList = action.payload.data;
      state.state.totalOrders = action.payload.totalOrders;
    },

    setCancelResons: (
      state,
      action: PayloadAction<{
        data: IOrderManagementCancelReasonData[];
      }>,
    ) => {
      state.state.cancelResons = action.payload.data;
    },
    setOrderFilter: (
      state,
      action: PayloadAction<{
        data: IOrderManagementOrderListProps;
      }>,
    ) => {
      state.state.orderFilter = action.payload.data;
    },
    setManualAssign: (
      state,
      action: PayloadAction<{
        data: IQCManualAssignDeleveryData[];
      }>,
    ) => {
      state.state.manualAssign = action.payload.data;
    },
    setUserPermision: (
      state,
      action: PayloadAction<{
        data: IQCUserPermision[];
      }>,
    ) => {
      state.state.userPermision = action.payload.data;
    },
    setOrderModule: (state, action: PayloadAction<string>) => {
      state.state.orderModule = action.payload;
    },
    setIsCentralAdmin: (state, action: PayloadAction<boolean>) => {
      state.state.isCentralAdmin = action.payload;
    },
    setIsOrderSearchActive: (state, action: PayloadAction<boolean>) => {
      state.state.isOrderSearchActive = action.payload;
    },
    setIsUserPopupModalActive: (state, action: PayloadAction<boolean>) => {
      state.state.isUserPopupModalActive = action.payload;
    },
    setTransferOrder: (
      state,
      action: PayloadAction<{
        data: ITransferOrderListResponseData[];
      }>,
    ) => {
      state.state.transferOrder = action.payload.data;
    },
    setTransferOrderOmsList: (
      state,
      action: PayloadAction<{
        data: ITransferOrderOMSListResponseData[];
      }>,
    ) => {
      state.state.transferOrderOmsList = action.payload.data;
    },
  },
});

export const {
  setCancelResons,
  setClinicList,
  setOrderList,
  setOrderStats,
  setOrderFilter,
  setOrderModule,
  setUserPermision,
  setIsCentralAdmin,
  setIsOrderSearchActive,
  setManualAssign,
  setTransferOrder,
  setOrderClinicList,
  setIsUserPopupModalActive,
  setTransferOrderStatsList,
  setTransferOrderOmsList,
} = orderManagementSlice.actions;
export default orderManagementSlice.reducer;
